import { Modal } from 'antd';
import React from 'react';

const PreviewModal = (props) => (
  <Modal {...props} destroyOnClose maskClosable={false} />
);

export default PreviewModal;
